import { CalendarHeart, MessageCircleHeart, Users, Sparkles, HandHeart, BookOpen, GraduationCap, Heart, Baby, Flower2, HeartHandshake, Timer, Building2, Stethoscope } from "lucide-react";
import { IMG } from "@/lib/content";
import { PASTORAL } from "@/lib/pastoral";

export const PAGES = {
  connect: {
    eyebrow: "Get Connected", title: "Let's take the next step together.",
    lead: "Wherever you are in your journey, we'd love to serve you. Choose whatever fits you best.", img: IMG.group,
    cards: [
      { icon: CalendarHeart, title: "Plan your visit", text: "Let us know you're coming and we'll be ready to welcome you.", action: "plan_visit", cta: "Plan my visit" },
      { icon: MessageCircleHeart, title: "Talk with a pastor", text: "Someone would love to listen, encourage and pray with you.", action: "talk_pastor", cta: "Reach out" },
      { icon: Users, title: "Join a Victory Group", text: "Small groups where friends grow in faith together.", action: "victory_group", cta: "Find a group" },
      { icon: Sparkles, title: "Know Jesus", text: "Discover God's love for you. We'd be honoured to walk with you.", href: "/#jesus", cta: "Learn more" },
      { icon: HandHeart, title: "Serve with us", text: "Use your gifts to bless others and honour God.", action: "serve", cta: "I'd love to serve" },
      { icon: Timer, title: "2-minute devotionals", text: "A short word of encouragement from our pastors every day.", href: "/devotionals", cta: "Watch now" },
    ],
  },
  "make-disciples": {
    eyebrow: "Discipleship", title: "Make disciples.",
    lead: "Thank you for your heart to help others know and follow Jesus. Let's walk this out together.", img: IMG.youth,
    cards: [
      { icon: Users, title: "Lead a Victory Group", text: "Open your life and help a few friends grow in Christ.", action: "make_disciples", cta: "I'm interested" },
      { icon: GraduationCap, title: "Get equipped", text: "Training and support to help you lead others well.", action: "make_disciples", cta: "Tell me more" },
      { icon: MessageCircleHeart, title: "Talk with a pastor", text: "Have questions about leading? A pastor would gladly help.", action: "talk_pastor", cta: "Reach out" },
    ],
  },
  "be-discipled": {
    eyebrow: "Discipleship", title: "Grow in your walk with God.",
    lead: "It would be our joy to walk with you, one step at a time, as you grow as a follower of Jesus.", img: IMG.bible,
    cards: [
      { icon: Heart, title: "Find someone to walk with you", text: "We'll connect you with a mature believer who can guide and encourage you.", action: "be_discipled", cta: "I want to be discipled" },
      { icon: Users, title: "Join a Victory Group", text: "Grow together with friends who share life and faith.", action: "victory_group", cta: "Find a group" },
      { icon: Timer, title: "Start your day with God", text: "Two-minute devotionals from our pastors and leaders.", href: "/devotionals", cta: "Watch now" },
    ],
  },
  journey: {
    eyebrow: "Journey", title: "The Discipleship Journey.",
    lead: "The Church's step-by-step course for growing as a follower of Jesus. Wherever you are, there's a next step for you.", img: IMG.bible,
    note: "[Journey class schedule and course details]",
    cards: [
      { icon: BookOpen, title: "Sign up for the next class", text: "We'll gladly let you know when the next class begins.", action: "journey", cta: "Sign me up" },
      { icon: MessageCircleHeart, title: "Have a question?", text: "We'd be happy to help you find the right step.", action: "talk_pastor", cta: "Ask us" },
    ],
  },
  "pastoral-care": {
    eyebrow: "Pastoral Care Services", title: "We're here for you in every season.",
    lead: "In life's celebrations and in its hardest moments, our pastors are honoured to serve you and your family.", img: IMG.praise,
    cards: [
      { icon: HeartHandshake, pastoral: "wedding", cta: "Request a schedule" },
      { icon: Baby, pastoral: "dedication", cta: "Request a schedule" },
      { icon: Flower2, pastoral: "memorial", cta: "Reach out to us" },
      { icon: Building2, pastoral: "property", cta: "Request a schedule" },
      { icon: MessageCircleHeart, pastoral: "counseling", cta: "Request a meeting" },
      { icon: Stethoscope, pastoral: "prayer_sick", cta: "Request a visit" },
    ].map((c) => ({ ...c, title: PASTORAL[c.pastoral].title, text: PASTORAL[c.pastoral].text, img: PASTORAL[c.pastoral].img })),
  },
};
